export const buildFileUrl = (filePath) => {
  if (!filePath) return null;
  if (/^https?:\/\//i.test(filePath)) return filePath;

  const backendBase = (process.env.REACT_APP_BACKEND || '').replace(/\/+$/, '');
  if (!backendBase) return filePath;

  const normalizedPath = String(filePath).replace(/^\/+/, '');
  return `${backendBase}/uploads/${normalizedPath}`;
};

export const REPORT_TYPES = {
  notice: {
    key: 'notice',
    label: 'Notice',
    endpoint: 'notices',
    statusOptions: ['active', 'inactive'],
    emptyForm: {
      name: '',
      date: '',
      notice_type: 'सामान्य',
      file: null,
      status: 'active',
    },
    fields: [
      { name: 'name', label: 'Notice Title', type: 'text', required: true },
      { name: 'date', label: 'Date', type: 'date', required: true },
      { name: 'notice_type', label: 'Notice Type', type: 'text' },
      { name: 'file', label: 'File (PDF/DOC)', type: 'file' },
      { name: 'status', label: 'Status', type: 'select', options: ['active', 'inactive'] },
    ],
  },
  annual: {
    key: 'annual',
    label: 'Annual Report',
    endpoint: 'downloads',
    statusOptions: ['active', 'inactive'],
    emptyForm: {
      report_title: '',
      publication_date: '',
      file: null,
      status: 'active',
    },
    fields: [
      { name: 'report_title', label: 'Report Title', type: 'text', required: true },
      { name: 'publication_date', label: 'Publication Date', type: 'date', required: true },
      { name: 'file', label: 'File (PDF/DOC)', type: 'file', required: true },
      { name: 'status', label: 'Status', type: 'select', options: ['active', 'inactive'] },
    ],
  },
  tender: {
    key: 'tender',
    label: 'Tender',
    endpoint: 'tenders',
    statusOptions: ['active', 'inactive', 'closed'],
    emptyForm: {
      tender_title: '',
      tender_description: '',
      published_date: '',
      sale_close_date: '',
      corrigendum: '',
      file: null,
      status: 'active',
    },
    fields: [
      { name: 'tender_title', label: 'Tender Title', type: 'text', required: true },
      { name: 'tender_description', label: 'Description', type: 'textarea' },
      { name: 'published_date', label: 'Published Date', type: 'date', required: true },
      { name: 'sale_close_date', label: 'Sale/Close Date', type: 'date' },
      { name: 'corrigendum', label: 'Corrigendum', type: 'text' },
      { name: 'file', label: 'File (PDF/DOC)', type: 'file' },
      { name: 'status', label: 'Status', type: 'select', options: ['active', 'inactive', 'closed'] },
    ],
  },
};

export const REPORT_ORDER = ['notice', 'annual', 'tender'];

export const getReportType = (key) => REPORT_TYPES[key] || REPORT_TYPES.notice;
